// deprecated

// Almost all credit goes to Rick Olson.
(function ($) {
  $.fn.relatizeDate = function () {
    return this.each(function () {
      var $el = $(this),
          datetime = $el.attr("datetime"),
          date_source = (typeof datetime !== 'undefined') ? datetime : $el.text(),
          date = moment(date_source);

      // If the date is invalid, leave the text as-is.
      if (date.isValid()) {
        $el.text(date.fromNow());
      }
    });
  };
})(jQuery);
